<template>
  <div class="room-extend-menu-component"
       :class="{'newWindow': newWindow }">
    <RoomCall
        v-if="!isRoomMode(['call', 'group']) && !newWindow && !Device.isMobile()"
        :secondVideo="isRoomMode(['screenShare'])"
        :videoOnly="true"
        :pip="true"
    />
    <div class="room-extend-menu" :class="{ showSection: !showChatSection }">
      <div class="room-extend-menu-contents">
        <div class="room-extend-menu-header">
          <div class="room-extend-menu-tab-list-wrapper">
            <ul class="room-extend-menu-tab-list">
              <li class="room-extend-menu-tab-item">
                <button class="room-extend-menu-tab-button chat"
                        :class="[
                            { selected: extendMenuTabType === 'chat' }, 
                            { showBadge: unreadChat }
                            ]" 
                        @click="onSelectExtendMenuType('chat')">
                  {{ $t("common.chat") }}
                </button>
              </li>
              <li v-if="useParticipantList" class="room-extend-menu-tab-item">
                <button class="room-extend-menu-tab-button" 
                        :class="{ selected: extendMenuTabType === 'participants' }" 
                        @click="onSelectExtendMenuType('participants')">
                  {{ $t("common.participant") }}<span class="room-user-count">{{filteredParticipants.length}}</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="room-extend-menu-more-button-wrapper">
            <button class="room-extend-menu-more-button" @click="onToggleExtendMenuMoreList"></button>
            <GrmMenu
              text-align="left"
              :open.sync="isOpenExtendMenuMoreList"
              :list="extendMenuMoreList"
            />
          </div>
        </div>
        <div class="room-extend-menu-body">
          <RoomChat v-show="extendMenuTabType === 'chat'"
                    ref="chat"
                    @onChangeSection="onChangeSection"
                    :extendMenuTabType="extendMenuTabType"
                    :newWindow="newWindow"
                    :chatHistoryProp="chatHistoryProp"/>
          <ParticipantList v-show="extendMenuTabType === 'participants'" />
        </div>
        <RoomExtendMenuSection :section="section"
                               :newWindow="newWindow"
                               @onChangeSection="onChangeSection" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import RoomCall from '@/components/Room/Call/RoomCall'
import ParticipantList from '@/components/Room/User/ParticipantList'
import GrmMenu from '@/components/Common/menu/GrmMenu'
import RoomChat from '@/components/Room/Chat/RoomChat'
import RoomExtendMenuSection from '@/components/Room/ExtendMenu/Section'
import {Device} from "@/utils";

export default {
  name: 'RoomExtendMenu',
  components: {
    RoomCall,
    ParticipantList,
    GrmMenu,
    RoomChat,
    RoomExtendMenuSection,
  },
  props: {
    newWindow: {
      type: Boolean,
      default: false,
    },
    chatHistoryProp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      extendMenuTabType: 'chat',
      isOpenExtendMenuMoreList: false,
      section: 'chat',
      unreadChat: false,
      showChatSection: true,
    }
  },
  watch: {
    extendMenuTabType: function (val) {
      if(this.isChatMenuTab){
        this.unreadChat = false;
      }
    },
  },
  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  computed: {
    ...mapGetters('user', ['roomUserList', 'hasEmceeRole', 'hasSpeakerRole', 'isMe']),
    ...mapGetters('room', ['isRoomMode', 'roomUserCount', 'roomInfoSetting', 'participantListRoleId']),
    chatHistory(){
      return this.$refs.chat.chatHistory;
    },
    Device() {
      return Device;
    },
    filteredParticipants() {
      return this.roomUserList.filter(p => {
        return p.roomUserRole.roleId !== 'obs'; // 옵저버 제외
      })
    },
    isChatMenuTab(){
      return this.extendMenuTabType == 'chat'
    },
    extendMenuMoreList() {
      let list = [
        {
          title: this.$t('extendMenu.section.notice'),
          icon: 'notice',
          click: () => {
            this.onChangeSection('notice')
          }
        },
        {
          title: this.$t('extendMenu.section.file'),
          icon: 'file',
          click: () => {
            this.onChangeSection('file')
          }
        },
        {
          title: this.$t('extendMenu.section.record'),
          icon: 'record',
          show: this.hasEmceeRole(),
          click: () => {
            this.onChangeSection('record')
          }
        },
        // {
        //   title: this.$t('extendMenu.section.note'),
        //   icon: 'empty_note',
        //   show: this.hasEmceeRole(),
        //   click: () => {
        //     this.onChangeSection('meetingNote')
        //   }
        // },
      ]
      
      if(!this.newWindow && !Device.isMobile()){
        list.push({
          title: this.$t('extendMenu.newWindow'),
          icon: 'chat',
          click: () => {
            this.$emit('closeExtendMenu')
            this.$emit('toggleNewWindowMenu')
          }
        })
      }
      
      return list
    },
    useParticipantList() {
      return this.participantListRoleId === 'speaker'
        ? this.hasSpeakerRole()
        : this.participantListRoleId === 'emcee'
          ? this.hasEmceeRole()
          : true
    }
  },
  methods: {
    onSelectExtendMenuType(type) {
      this.extendMenuTabType = type
    },
    onToggleExtendMenuMoreList() {
      this.isOpenExtendMenuMoreList = !this.isOpenExtendMenuMoreList
    },
    onChangeSection(section = 'chat') {
      const isChatSection = section === 'chat'
      this.showChatSection = isChatSection;

      if (isChatSection) {
        setTimeout(() => {
          this.section = section;
        }, 200);
      } else {
        this.section = section;
      }
    },
    showChatBadge(){
      if(!this.isChatMenuTab){
        this.unreadChat = true;
      }
    },
    updateParticipantListByRoleId(roleId) {
      if (this.participantListRoleId === 'speaker') {
        if (!this.hasSpeakerRole()) {
          this.onSelectExtendMenuType('chat')
        }
      } else if (this.participantListRoleId === 'emcee') {
        if (!this.hasEmceeRole()) {
          this.onSelectExtendMenuType('chat')
        }
      }
    }
  }
}

function _Events() {
  return {
    room_chat_text: function (e) {
      this.showChatBadge();
    },
    room_file_add: function (e) {
      this.showChatBadge();
    },
    room_changeUserRoleId (e) {
      const { userId, roleId } = e.data;
      if (this.isMe(userId)) {
        this.updateParticipantListByRoleId(roleId)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.room-extend-menu-component {
  display: flex;
  flex-direction: column;
  position: relative;
  visibility: hidden;
  width: 0;
  background-color: #ddd;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);  
  transition: 300ms ease-out;
  z-index: 1;
    
  &.isOpen {
    width: 300px;
    visibility: visible;
  }
  &.newWindow {
    width: 100%;
    height: 100%;
    visibility: visible;
    .room-extend-menu {
      width: 100%;
    }
  }
}
.room-extend-menu {
  width: 300px;
  flex: 1;
  min-height: 0;
  background-color: #fff;
  overflow: hidden;
  &.showSection {
    .room-extend-menu-contents {
      left: -100%;
    }
  }
}
.room-extend-menu-contents {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 0;
  transition: 0.2s ease-out;
}
.room-extend-menu-header {
  height: 47px;
  display: flex;
  border-bottom: 1px solid #aaa;
}
.room-extend-menu-tab-list-wrapper {
  flex: 1;
}
.room-extend-menu-tab-list {
  height: 100%;
  display: flex;
}
.room-extend-menu-tab-item {
  flex: 1;
}
.room-extend-menu-tab-button {
  width: 100%;
  height: 100%;
  font-size: 15px;
  position: relative;
  &.showBadge::before {
    content: "";
    width: 5px;
    height: 5px;
    background: #f05;
    position: absolute;
    top: 30%;
    right: 32%;
    border-radius: 100%;
    //display: none;
  }
  &::after {
    content: '';
    background-color: $mainColor;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 3px;
    opacity: 0;
    visibility: hidden;
    transition: 0.1s ease-out;
  }
  &.selected {
    font-weight: 700;
    &::after {
      opacity: 1;
      visibility: visible;
    }
  }
}
.room-user-count {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 700;
  color: $mainColor;
}
.room-extend-menu-more-button-wrapper {
  position: relative;
  .grm-menu-component {
    min-width: max-content;
    position: absolute;
    top: 34px;
    right: 26px;
  }
}
.room-extend-menu-more-button {
  width: 44px;
  height: 100%;
  background: url('~@/assets/images/more_vertical_gray.svg') no-repeat center / 4px auto;
}
.room-extend-menu-body {
  position: relative;
  flex: 1;
}
.room-chat-component,
.participant-list-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

// Component
.room-call-component {
  width: 300px;
  height: 168px;
}
.room-extend-menu-section-component {
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 100%;
}

[grm-device-mobile] {
  @media (max-width: 768px) {
    .room-extend-menu-component {
      width: calc(100% - 60px) !important;
      height: calc(100% - 50px);
      align-items: center;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 60px;
      transform: translateX(100%);
      &.isOpen {
        transform: translateX(0);
      }
    }
    .room-extend-menu {
      width: 100%;
    }
  }
}
</style>